module.exports = __webpack_public_path__ + "img/menu_EVAL.ae46fc97.svg";